<!-- Test Mode Banner -->
<div *ngIf="(configService.systemConfigSubject | async)?.apiMode == 'test'" id="test-mode-banner" [class]="bannerClasses">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2"/>
    <path d="M6.453 15h11.094"/>
    <path d="M8.5 2h7"/>
  </svg>
  You are using Fasten in test mode
</div>

<ng-container *ngIf="isSigninRoute; else appShell">
  <div class="marketing-container">
    <router-outlet></router-outlet>
  </div>
</ng-container>

<ng-template #appShell>
  <ng-container *ngIf="isDashboardChromeRoute; else secondaryShell">
    <div class="vault-app-shell">
      <header class="vault-shell-header">
        <div class="vault-shell-header-row">
          <div class="vault-shell-logo">
            <span class="az-logo text-2xl">fasten</span>
          </div>

          <nav class="vault-shell-nav" aria-label="Vault sections">
            <a style="display:none;"
              [routerLink]="'/dashboard/apps'"
              class="vault-shell-nav-link"
              [class.is-active]="activeDashboardSection === 'apps'">
              Apps
            </a>
            <a
              [routerLink]="'/dashboard/accounts'"
              class="vault-shell-nav-link"
              [class.is-active]="activeDashboardSection === 'accounts'">
              Accounts
            </a>
            <a
              [routerLink]="'/dashboard/settings'"
              class="vault-shell-nav-link"
              [class.is-active]="activeDashboardSection === 'settings'">
              Settings
            </a>
          </nav>

          <details class="vault-shell-profile">
            <summary class="vault-profile-trigger">
              <img src="assets/images/profile-image.svg" alt="" class="vault-profile-avatar">
              <span class="vault-profile-label">Profile</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </summary>

            <div class="vault-profile-menu">
              <a [routerLink]="'/dashboard/settings'" class="vault-profile-menu-item">Settings</a>
              <a [routerLink]="'/auth/signin'" class="vault-profile-menu-item">Sign out</a>
            </div>
          </details>
        </div>
      </header>

      <main class="vault-shell-main">
        <router-outlet></router-outlet>
      </main>
    </div>
  </ng-container>

  <ng-template #secondaryShell>
    <div [ngClass]="isWideSurfaceRoute ? 'vault-wide-surface' : 'mx-auto w-full max-w-[440px] bg-white rounded-[28px] shadow-[0_24px_80px_rgba(15,23,42,0.12)] border border-white/70'">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</ng-template>
